import { createLogger } from '@updater-core/lib/logger';
import { ENVIRONMENT } from '@updater-core/lib/environment';

export const { log } = createLogger(
  ENVIRONMENT?.debug?.moveItems,
  '[MOVE_ITEMS]',
  'color: #d67cd0'
);
